export default __webpack_public_path__ + "static/media/Banner-C-Carpet.0f7fb5a9.jpg";